export const INFO_TYPE = 'info'
export const NO_PARTS_CONFIGURED_MESSAGE =
    'Please configure all parts in order to receive a quote and lead time options.'
export const PROJECT_REQUIREMENTS_AND_PARTS_NOT_CONFIG_MESSAGE =
    'Please enter project requirements and configure all parts before requesting for quote.'
export const MANUAL_QUOTE_REQUIRED_MESSAGE =
    'Some parts in your quote cannot be instantly quoted. Please request a quote and a Fictiv admin will work to provide an accurate quote, typically within 2 business hours.'
export const QUANTITY_ERROR_MESSAGE =
    'Please enter valid part quantity to begin checkout, download quote, or forward to purchaser.'

export const IM_MANUAL_QUOTE_REQUIRED_MESSAGE =
    'Your quote is ready to be requested. Please click “Request quote” and we will work to provide pricing and preliminary DFM analysis.'

export const NOT_PURCHASABLE_MESSAGE =
    'Some parts are not ready to be purchased. Please review the feedback provided.'

export const QUOTE_EXPIRED =
    'Your quote has expired. Please request for a new quote.'

export const REQUEST_QUOTE = 'Request quote'

export const PROCEED_TO_CHECKOUT = 'Proceed to checkout'

export const BEGIN_CHECKOUT = 'Begin checkout'

export const CANNOT_CHECKOUT_MESSAGE =
    'Your quote cannot be checked out at this time. Please make sure all parts are fully configured, have valid quantity and have been quoted for a price.'
export const CANNOT_DOWNLOAD_MESSAGE =
    'Your quote cannot be downloaded at this time. Please make sure all parts are fully configured, have valid quantity and have been quoted for a price.'
export const CANNOT_FORWARD_MESSAGE =
    'Your quote cannot be forwarded at this time. Please make sure all parts are fully configured, have valid quantity and have been quoted for a price.'
export const CANNOT_REQUEST_QUOTE_MESSAGE =
    'You cannot request a quote at this time. Please make sure all parts are fully configured and have a valid quantity.'

export const CPQ_QUOTE_STATUS = [
    {
        index: 0,
        title: 'Requested',
    },
    {
        index: 1,
        title: 'In progress',
    },
    {
        index: 2,
        title: 'Ready to review',
    },
]
